import { ProcedureTypes } from "../procedures";

export enum FormSlugs {
    // Referral
    Referral = "referral",
    ReferralAuth = "referral-auth",
    AsnDocumentOfGift = "asn-document-of-gift",
    AsnResearchAuth = "asn-research-auth",
    AsnResearchDrai = "asn-research-drai",
    AsnTransplantAuth = "asn-transplant-auth",
    AsnTransplantDrai = "asn-transplant-drai",
    LohDocumentOfGift = "loh-document-of-gift",
    LohTransplantAuth = "loh-transplant-auth",

    // Recovery
    Recovery = "recovery",
    DonorOmar = "donor-omar",

    // Medical Chart Review
    MedicalRecordsRequest = "medical-records-request",
    PrelimAutopsyFindings = "prelim-autopsy-findings",
    DED = "ded",
    PlasmaDilutionWorksheet = "plasma-dilution-worksheet",
    SummaryOfRecords = "summary-of-records",

    // Processing
    ProcessingMicrokeratome = "processing-microkeratome",
    ProcessingDmek = "processing-dmek",
    ProcessingCornealExcision = "processing-corneal-excision",
    ProcessingCairs = "processing-cairs",
    ProcessingTissueTransfer = "processing-tissue-transfer",

    // Distribution
    ImportTissueDocumentation = "import-tissue-documentation",
    PostOp3To6Month = "post-op-3-to-6-month",
    TIF = "tif",
    TissueRecipientInfo = "tissue-recipient-info",
    TissueOmarImport = "tissue-omar-import",
    TissueOmarProcessReturn = "tissue-omar-process-return",
    TissueOmarReturned = "tissue-omar-returned",
    TissueOmarSatelliteTransfer = "tissue-omar-satellite-transfer",

    // QA
    DonorReview = "donor-review",
    EventReport = "event-report",
    QaAudit = "qa-audit",
    QaDonorChartAudit = "qa-donor-chart-audit",
}

export const getFormSlugForProcedureType = (procedureType: string): FormSlugs | undefined => {
    switch (procedureType) {
        case ProcedureTypes.CAIRS:
            return FormSlugs.ProcessingCairs;
        case ProcedureTypes.DMEKPatientReady:
        case ProcedureTypes.DMEKPreloaded:
        case ProcedureTypes.DMEKStandard:
            return FormSlugs.ProcessingDmek;
        case ProcedureTypes.LabCornealExcision:
        case ProcedureTypes.ScleraPreservationHalf:
        case ProcedureTypes.ScleraPreservationQuarter:
        case ProcedureTypes.ScleraPreservationWhole:
            return FormSlugs.ProcessingCornealExcision;
        case ProcedureTypes.MicrokeratomeDSAEK:
        case ProcedureTypes.MicrokeratomeDSAEKPreloaded:
        case ProcedureTypes.MicrokeratomeDSAEKTrephined:
        case ProcedureTypes.MicrokeratomeALK:
        case ProcedureTypes.MicrokeratomeLenticule:
            return FormSlugs.ProcessingMicrokeratome;
        case ProcedureTypes.TissueTransferAntifungal:
        case ProcedureTypes.TissueTransferSection:
        case ProcedureTypes.TissueTransferOther:
        case ProcedureTypes.AsgCornea:
            return FormSlugs.ProcessingTissueTransfer;
        default:
            return undefined;
    }
};
